import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { numberToOption } from 'modules/admin-panel/pages/results/helpers';
import { MuiCustomSelect } from 'components/base/mui-custom-select';

import { useStyles } from 'components/base/pagination/pagination.styles';

interface ItemsPerPageSelectProps {
	pageSizeOptions: number[];
	itemsPerPage: number;
	changeItemsPerPage: (v: number) => void;
	wrapperClass?: string;
}

export const ItemsPerPageSelect = ({
	pageSizeOptions,
	itemsPerPage,
	changeItemsPerPage,
	wrapperClass,
}: ItemsPerPageSelectProps) => {
	const { t } = useTranslation('results');
	const classes = useStyles();

	const options = useMemo(() => pageSizeOptions.map(numberToOption), [
		pageSizeOptions,
	]);

	const handleChange = useCallback(
		(v: unknown) => {
			changeItemsPerPage(v as number);
		},
		[changeItemsPerPage],
	);

	return (
		<MuiCustomSelect
			selectClassName={cn(wrapperClass, classes.itemsPerPageSelect)}
			name="items-per-page-switcher"
			id="items-per-page-switcher"
			label={t('per_page')}
			options={options}
			value={itemsPerPage}
			onSelectChange={handleChange}
		/>
	);
};
